<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><span class="small">DEDICATION</span></p>
<p class="center1">To truck drivers everywhere.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?c97f76c0